import { configureStore } from "@reduxjs/toolkit";
import slaReducer from "./features/sla/slaSlice";
import authReducer from "./features/auth/authSlice";

export default configureStore({
  reducer: {
    auth: authReducer,
    SLA: slaReducer,
  },
});
